import { render, staticRenderFns } from "./DocumentNumberInput.vue?vue&type=template&id=511e2af4&scoped=true&"
import script from "./DocumentNumberInput.vue?vue&type=script&lang=ts&"
export * from "./DocumentNumberInput.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentNumberInput.vue?vue&type=style&index=0&id=511e2af4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511e2af4",
  null
  
)

export default component.exports